"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = {
    separator: ' - ',
    maximumRequestSizeExceeded: 'MAXIMUM_REQUEST_SIZE_EXCEEDED'
};
exports.MaxCloudfrontRequestSize = 8192;
//# sourceMappingURL=consts.js.map